// This file added by Bearer Web Developer - Schedule as a Future Order
import React from 'react';
import { useAppState } from '../../../../states/app-state';
import { observer } from "mobx-react-lite";
import EarliestPickup from './earliestPickup';
import LatestPickup from './latestPickup';
import { Button } from '@mui/material';
import styles from './scheduleEditor.module.scss';
import { useThemeMode } from '../../../../states/contexts/theme';
import timeSensitiveManagement from '../../../reservedOrdersPopup/earliestTime/timeSensitiveManagement';
const ScheduleEditor: React.FC = observer(() => {

    const appstate = useAppState();
    const order = appstate?.selectedOrder;
    const scheduleOrder = appstate?.selectedOrder?.scheduleOrder;
    const editing = scheduleOrder?.editing;
    const isReadyForPayment = order?.isReadyForPayment;
    const { theme } = useThemeMode()
    return (
        <div className={styles.schedule_editor} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <EarliestPickup />
            <LatestPickup />
            <p>
                <img src="/note.svg" alt="note" />
                If no Bearer accepts the job by the latest pickup time, it will be automatically cancelled at no cost.
            </p>
            <Button className={styles.confirm} disabled={scheduleOrder?.latestTime === '' && scheduleOrder?.latestDate === ''} variant="contained" color="primary"
                onClick={() => {
                    if (!isReadyForPayment) return;
                    if (scheduleOrder?.latestTime === '' && scheduleOrder?.latestDate === '') return;
                    scheduleOrder?.setTimeSensitive(timeSensitiveManagement(scheduleOrder?.earliestPickupTime));
                    if (editing) scheduleOrder?.setEditing(false);
                }}
            >Confirm Schedule</Button>
        </div>
    )
})
export default ScheduleEditor;